import { useContext } from "react";
import { SportsCampsContext } from "../context/sportscamps-context";

const Loading = () => {
	const { dictionaryWords } = useContext(SportsCampsContext);
	return (
		<div className="status loading">
			<i className="loader"></i>
			<h1>{dictionaryWords.loading}</h1>
		</div>
	);
};

export default Loading;
